import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ resource, filter }) =>
    present(
      repository
        .getNotifications(resource, filter)
        .then((response) => ({
          resource,
          notifications: response.notifications,
          filter,
          totalPages: response.totalPages,
        }))
        .catch(() => Promise.reject({ resource, filter })),
    );
}

export type { Interactor };

export { createInteractor };
